module.exports = __webpack_public_path__ + "img/FR10107.8859ba88.png";